"use client"

import { useSession } from "next-auth/react"
import React from "react"
import { H1CTA } from "@/components/home/H1CTA"

interface SidebarProps {
   children?: React.ReactNode
   hideDefaultNewsletter?: boolean
   className?: string
}

function Sidebar({ children, hideDefaultNewsletter = false, className = "" }: SidebarProps) {
   const { data: session, status } = useSession()
   const isLoggedIn = status === "loading" || !!session?.user

   const showCTA = !isLoggedIn && !hideDefaultNewsletter
   const childrenArray = React.Children.toArray(children)

   const stickyClass = "lg:sticky lg:top-36"

   return (
      <aside className={`relative flex h-full flex-col ${children ? "gap-10" : "gap-0"} md:pl-6 lg:gap-0 ${className}`}>
         {childrenArray.map((child, index) => {
            if (!child) return null

            const isLastChild = !showCTA && index === childrenArray.length - 1

            let childOrderClasses = ""

            if (React.isValidElement(child)) {
               const elementProps = child.props as { className?: string }
               if (elementProps.className) {
                  const classes = elementProps.className.split(" ")
                  childOrderClasses = classes.filter((c: string) => c.includes("order-")).join(" ")
               }
            }

            const wrapperClass = `${isLastChild ? stickyClass : ""} ${childOrderClasses}`.trim()

            return (
               <div key={index} className={wrapperClass}>
                  {child}
               </div>
            )
         })}

         {showCTA && (
            <div className={`mt-8 hidden lg:block ${stickyClass} lg:order-last`}>
               <H1CTA layout="stacked" />
            </div>
         )}
      </aside>
   )
}

export default Sidebar
